import FqApi from '@/services/fq-api'

export default {
  async getQuoteIdByNo(quoteNo) {
    const result = await FqApi.get(`quotes/quoteidbyno?quoteNo=${encodeURIComponent(quoteNo)}`)
    return result.data
  }
}
